// extracted by mini-css-extract-plugin
export default {"pocSidebar":"styles_pocSidebar__6Y2rO","selected":"styles_selected__DZBfH"};